import '@/common';
import { createGroupedLinksListWidget } from '@/widgets/GroupedLinksListWidget';

createGroupedLinksListWidget(document.querySelector('#grouped-links-list-widget')!);
